<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>จัดการปี</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="justify-end">
                <v-col cols="12" md="8">
                  <v-btn
                    color="primary"
                    title="เพิ่มปี"
                    outlined
                    small
                    @click="openDialogCreateYear"
                  >
                    <v-icon left>fa-plus</v-icon>
                    เพิ่มปี
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="yearSearch"
                    label="ค้นหา"
                    solo
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-data-table
                :search="yearSearch"
                :loading="yearLoading"
                :headers="yearHeaders"
                :items="years"
                :items-per-page="100"
                sort-by="id"
                :footer-props="{
                  itemsPerPageOptions: [25, 50, 75, 100, -1],
                }"
              >
                <template v-slot:[`item.no`]="{ index }">
                  {{ index + 1 }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-2"
                    title="แก้ไขข้อมูล"
                    small
                    @click="editYear(item)"
                  >
                    fa-edit
                  </v-icon>
                  <v-icon
                    color="danger"
                    class="mr-2"
                    title="ลบข้อมูล"
                    small
                    :disabled="item.can_delete"
                    @click="deleteYear(item.id)"
                  >
                    fa-trash
                  </v-icon>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col cols="12" md="6">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>จัดการคณะ/สาขา</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="justify-end">
                <v-col cols="12" md="8">
                  <v-btn
                    color="primary"
                    title="เพิ่มคณะ"
                    outlined
                    small
                    @click="openDialogCreateFaculty"
                  >
                    <v-icon left>fa-plus</v-icon>
                    เพิ่มคณะ
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="facultySearch"
                    label="ค้นหา"
                    solo
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-data-table
                :search="facultySearch"
                :loading="facultyLoading"
                :headers="facultyHeaders"
                :items="faculties"
                :items-per-page="100"
                sort-by="id"
                :footer-props="{
                  itemsPerPageOptions: [25, 50, 75, 100, -1],
                }"
              >
                <template v-slot:[`item.no`]="{ index }">
                  {{ index + 1 }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-2"
                    title="ดูสาขาทั้งหมด"
                    small
                    @click="showMajors(item.id)"
                  >
                    fa-eye
                  </v-icon>
                  <v-icon
                    color="primary"
                    class="mr-2"
                    title="แก้ไขข้อมูล"
                    small
                    @click="editFaculty(item)"
                  >
                    fa-edit
                  </v-icon>
                  <v-icon
                    color="danger"
                    class="mr-2"
                    title="ลบข้อมูล"
                    small
                    :disabled="item.can_delete"
                    @click="deleteFaculty(item.id)"
                  >
                    fa-trash
                  </v-icon>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <DialogCreateYear :dialog.sync="dialogCreateYear" />
    <DialogEditYear :dialog.sync="dialogEditYear" :year="showYear" />

    <DialogCreateFaculty :dialog.sync="dialogCreateFaculty" />
    <DialogEditFaculty
      :dialog.sync="dialogEditFaculty"
      :faculty="showFaculty"
    />
    <DialogShowMajors
      :dialog.sync="dialogShowMajors"
      :loading="facultyMajorsLoading"
      :facultyId="facultyId"
      :majors="facultyMajors"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import {
  UPDATE_BREADCRUMBS,
  GET_FACULTIES,
  DELETE_FACULTY,
  GET_MAJORS_BY_FACULTY,
  GET_YEARS,
  DELETE_YEAR,
} from "@/store/action.type"
import { CONFIRM_DELETE } from "@/common/consistent"
import { swalConfirm } from "@/common/alert"
import { DialogCreateYear, DialogEditYear } from "@/components/dialog/year"
import {
  DialogCreateFaculty,
  DialogEditFaculty,
} from "@/components/dialog/faculty"
import { DialogShowMajors } from "@/components/dialog/major"

export default {
  name: "OfficeSetting",
  title: "ตั้งค่า",
  components: {
    DialogCreateFaculty,
    DialogEditFaculty,
    DialogShowMajors,
    DialogCreateYear,
    DialogEditYear,
  },
  created() {
    this.$store.dispatch(UPDATE_BREADCRUMBS, [
      {
        text: "ตั้งค่า",
        disabled: false,
        exact: true,
        to: { name: "OfficeSetting" },
      },
    ])
  },
  data() {
    return {
      facultySearch: "",
      facultyHeaders: [
        { text: "ID", value: "id" },
        { text: "ชื่อคณะ", value: "name" },
        { text: "ตัวเลือก", value: "actions" },
      ],
      showFaculty: {},
      dialogCreateFaculty: false,
      dialogEditFaculty: false,

      facultyId: "",
      dialogShowMajors: false,

      yearSearch: "",
      yearHeaders: [
        { text: "ID", value: "id" },
        { text: "ชื่อปี", value: "name" },
        { text: "ตัวเลือก", value: "actions" },
      ],
      showYear: {},
      dialogCreateYear: false,
      dialogEditYear: false,
    }
  },
  computed: {
    ...mapGetters([
      "faculties",
      "facultyLoading",
      "facultyMajors",
      "facultyMajorsLoading",
      "years",
      "yearLoading",
    ]),
  },
  mounted() {
    this.getFaculty()
    this.getYear()
  },
  methods: {
    getFaculty() {
      this.$store.dispatch(GET_FACULTIES)
    },
    getYear() {
      this.$store.dispatch(GET_YEARS)
    },
    openDialogCreateFaculty() {
      this.dialogCreateFaculty = true
    },
    openDialogCreateYear() {
      this.dialogCreateYear = true
    },
    editFaculty(faculty) {
      this.showFaculty = faculty
      this.dialogEditFaculty = true
    },
    editYear(year) {
      this.showYear = year
      this.dialogEditYear = true
    },
    deleteFaculty(facultyId) {
      swalConfirm("warning", CONFIRM_DELETE, () => {
        this.$store.dispatch(DELETE_FACULTY, facultyId)
      })
    },
    deleteYear(facultyId) {
      swalConfirm("warning", CONFIRM_DELETE, () => {
        this.$store.dispatch(DELETE_YEAR, facultyId)
      })
    },
    showMajors(facultyId) {
      this.$store.dispatch(GET_MAJORS_BY_FACULTY, facultyId)
      this.facultyId = facultyId
      this.dialogShowMajors = true
    },
  },
}
</script>
